<template>
  <div
    class="absolute z-[99] tooltip-shadow bg-[#fff] p-[10px] rounded-[8px] shadow border w-[150px]"
  >
    <div id="task-item-edit-popper">
      <div
        @click.stop="handleRename"
        :class="[
          'flex justify-start text-[14px] items-center text-[#1c1c1e] gap-[5px] w-full p-[5px] rounded-[4px]',
          {
            'hover:bg-[#f5f5f5] cursor-pointer': !layoutStore.dialogLoadingRef,
            'opacity-50 cursor-not-allowed pointer-events-none': layoutStore.dialogLoadingRef
          }
        ]"
      >
        <i-ep-edit />
        重命名
      </div>

      <div
        @click.stop="handleClone"
        :class="[
          'flex justify-start text-[14px] items-center text-[#1c1c1e] gap-[5px]    w-full p-[5px] rounded-[4px]',
          {
            'opacity-50 cursor-not-allowed pointer-events-none':
              layoutStore.dialogLoadingRef || disabled,
            'hover:bg-[#f5f5f5] cursor-pointer': !disabled
          }
        ]"
      >
        <el-icon><i-ep-copyDocument /></el-icon>
        克隆
      </div>

      <div
        @click.stop="handleDelete"
        :class="[
          'flex justify-start text-[14px] items-center text-[#1c1c1e] gap-[5px]   w-full p-[5px] rounded-[4px]',
          {
            'hover:bg-[#f5f5f5] cursor-pointer': !layoutStore.dialogLoadingRef,
            'opacity-50 cursor-not-allowed pointer-events-none': layoutStore.dialogLoadingRef
          }
        ]"
      >
        <i-ep-delete color="red" />

        删除
      </div>
    </div>
  </div>
</template>
<script setup>
import { useTaskStore } from '@/store/taskStore'
import { useLayoutStore } from '../../store/layoutStore'
import { computed } from 'vue'
const taskStore = useTaskStore()
const layoutStore = useLayoutStore()

const props = defineProps({
  taskId: {
    type: [String, Number],
    required: true,
    validator: (value) => {
      if (!value) {
        console.warn('taskId is required')
        return false
      }

      return true
    }
  }
})
const emits = defineEmits(['rename', 'clone', 'delete'])
const taskInfo = computed(() => {
  return taskStore.rawTasks[props.taskId]
})
const taskStatus = computed(() => {
  return taskStore.rawTasks[taskInfo.value.id].status
})

const disabled = computed(() => {
  return taskStatus.value === '草稿'
})
const handleRename = () => {
  emits('rename')
}
const handleClone = () => {
  if (disabled.value) return
  emits('clone')
}
const handleDelete = () => {
  emits('delete')
}
</script>
<style lang="scss" scoped></style>
